<template>
  <div class="container" >
    
    <div  v-if="paramsBool" class="row">
      <div class="col">
      <h4 class="mt-4">Thank you for completing the onboarding questionnaire!</h4><br>
      <p>Here is how to interact with this page:</p>
      <ul>
        <li class="mb-2">The first three items will show how your workplace answered versus the average answer. You can use this information for drawing comparisons.</li>
        <li> The next seven items show how all workplaces have answered. However, if you remember how you responded to these items, you can still draw comparisons as well. These items have the ability for you to hover over each answer choice for more details (e.g., number of respondents for each answer choice).</li>
      </ul>
      </div>
    </div>
    <div  v-else v-show="dataReady" class="row">
      <div class="col">
      <h4 class="mt-4">There has been an error on this page. We apologize for the inconvenience.</h4><br>
      <!-- <p>Here is how to interact with this page:</p>
      <ul>
        <li class="mb-2">The first three items will show how your workplace answered versus the average answer. You can use this information for drawing comparisons.</li>
        <li> The next seven items show how all workplaces have answered. However, if you remember how you responded to these items, you can still draw comparisons as well. These items have the ability for you to hover over each answer choice for more details (e.g., number of respondents for each answer choice).</li>
      </ul> -->
      </div>
    </div>

    <hr>
    
  
    <div v-show="paramsBool">
    <!-- q11 -->
    <div class="row results-check" v-if="dataReady">
      <div class="col-lg-1"></div>      
      <div class="col-lg-10">
        <div class="row">
        <bar-chart :chartNum="0" :data="results['Q13']" :questions="data[12]" :benchmark="barcharts[0]" :test="barcharts[0]" :avg="makeAverage(barcharts[0])" :tooltip="tooltips[0]"/>
        </div>
        <div class="row">
          <bar-chart :chartNum="1" :data="results['Q18']" :questions="data[17]" :benchmark="barcharts[1]" :test="barcharts[1]" :avg="makeAverage(barcharts[1])" :tooltip="tooltips[1]"/>
        </div>
        <div class="row">
          <bar-chart :chartNum="2" :data="results['Q12']" :questions="data[11]" :benchmark="barcharts[2]" :test="barcharts[2]" :avg="makeAverage(barcharts[2])" :tooltip="tooltips[2]"/>
        </div>
        
      </div>
      <!-- q12 -->
      <div class="col-lg-5">
        
      </div>
    </div>

    <div class="row mt-5" v-if="dataReady">
      <!-- q13 -->
      <div class="col-lg-1 mt-2"></div>
      <div class="col-10 mt-2">
        <bar-chart-vert :benchmark="barchartverts[0]" :question="data[10]" :tooltip="tooltips[3]" :avg='data[10].ID' />
      </div>
      <!-- q14 -->
      <!-- <div class="col-xl-2"></div>  -->
      <div class="col-lg-1 mt-2"></div>
      <div class="col-lg-1 mt-2"></div>
      <div class="col-10 mt-2">
        <bar-chart-vert :benchmark="barchartverts[1]" :question="data[16]" :tooltip="tooltips[4]" :avg='data[16].ID'/>
      </div>
      <div class="col-lg-1 mt-2"></div>
      <div class="col-lg-1 mt-2"></div>
      <div class="col-10 mt-2" v-if="dataReady">
        <bar-chart-vert :data="results" :benchmark="barchartverts[2]" :question="data[18]" :tooltip="tooltips[5]" :avg='data[18].ID'/>
        
      </div>
    </div>
    <div class="row mt-5">
      <!-- q16 -->
      <!-- <div class="col-xl-3"></div>  -->
      
      <!-- q17 -->
      <!-- <div class="col-lg-5">
        
      </div> -->
    </div>
    <div class="row mt-5" v-if="dataReady">
      <!-- q18 -->
      <div class="col-lg-1"></div> 
      <div class="col-lg-10">
        <bar-chart-l-2-g :benchmark="barchartl2gs[0]" :question="data[15]" :tooltip="tooltips[6]" :avg='data[15].ID' />
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-1"></div>
      <!-- q19 -->
      <div class="col-lg-10">
        <bar-chart-l-2-g :benchmark="barchartl2gs[1]" :question="data[13]" :tooltip="tooltips[7]" :avg='data[13].ID' />
      </div>
    </div>
    <div class="row mt-5" v-if="dataReady">
      <!-- q20 -->
      <div class="col-lg-1"></div> 
      <div class="col-lg-10 ">
        <pie-chart :benchmark="piecharts[0]" :question="data[19]" :tooltip="tooltips[8]" :avg='data[19].ID' />
      </div>
      <div class="col-lg-1"></div> 
      <div class="col-lg-1"></div> 
      <!-- q21 -->
      <div class="col-lg-10 pt-2">
        <pie-chart :benchmark="piecharts[1]" :question="data[20]" :tooltip="tooltips[9]" :avg='data[20].ID' />
      </div>
      <div class="col-lg-1"></div> 
    </div>
    </div>
  </div>
  <popover ref="popover" />
</template>
<script>
import store from "../store";
// import useRouter from 'vue-router'
import BarChart from "./results-components/BarChart.vue";
import PieChart from "./results-components/PieChart.vue";
import { SurveyData } from "../data";
import { benchmark } from "../benchmark.js";
import BarChartVert from "./results-components/BarChartVert.vue";
import BarChartL2G from "./results-components/BarChartL2G.vue";

export default {
  components: { BarChart, PieChart, BarChartVert, BarChartL2G },
  data() {
    return {
      results: store.state.surveyAnswers,
      data: SurveyData,
      benchmark: benchmark,
      benchmark2: null,
      dataReady: false,
      paramsBool : store.state.paramsBool
    };
  },

  methods: {
    categoryTrim(str){
      return str.lastIndexOf("(") > 0 ? str.slice(0,str.lastIndexOf("(")).trim() : str.lastIndexOf("?") > 0 ? str.slice(0,str.lastIndexOf("?")).trim() : str.trim()
    },
    showModal(modal, data) {
      store.showModal(modal, data);
    },
    hideModal() {
      store.hideModal();
    },
    makeAverage(arr) {
      return 9 - ((arr.map((x,i)=> x*i).reduce((p,c)=>p+c,0))/(arr.reduce((p,c)=>p+c,0)) * 8.5 / arr.length)
    }
  },
  setup() {
    // const router = useRouter()

    // fetch("https://nsc-org-dev.azurewebsites.net/Survey/GetSurveys",{
    //                 method: "GET",
    //                 mode: "cors",
    //                 cache: "no-cache",
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
    //                 }}).then(data=> {return data.json()}).then(data=>store.state.benchmark=store.buildBenchmark(data))//console.log('BENCHMARK', store.buildBenchmark(data)))
    // console.log("SETUP",store.state.benchmark)

    if (JSON.stringify(store.state.surveyAnswers) === "{}") {
      // console.log("LOAD FROM URI");
      let queryString = window.location.hash.split("?")[1];
      let urlParams = new URLSearchParams(queryString);


      try {let [Q11, Q12, Q13, Q14, Q16, Q17, Q18, Q19, Q20, Q21] = [
        (() => {
          let temp = urlParams.get("11").split(",");
          let obj = {};
          temp.map((x, i) => {
            obj[`q${i + 1}`] = x;
          });
          return obj;
        })(),
        urlParams.get("12"),
        urlParams.get("13"),
        (() => {
          let temp = urlParams.get("14").split(",");
          return temp;
        })(),
        (() => {
          let temp = urlParams.get("16").split(",");
          return temp;
        })(),
        (() => {
          let temp = urlParams.get("17").split(",");
          let obj = {};
          temp.map((x, i) => {
            obj[`q${i + 1}`] = x;
          });
          return obj;
        })(),
        urlParams.get("18"),
        (() => {
          let temp = urlParams.get("19").split(",");
          let obj = {};
          temp.map((x, i) => {
            obj[`q${i + 1}`] = x;
          });
          return obj;
        })(),
        urlParams.get("20"),
        urlParams.get("21"),
      ];

      store.loadFromURI([Q11, Q12, Q13, Q14, Q16, Q17, Q18, Q19, Q20, Q21]);
      } catch(e){
        store.state.paramsBool = false
        // router.push({path:"/404"})
        console.log (e)
      }
    }
  },
  async mounted(){
    // if (window.innerWidth<1000){
    //   widthBool == true
    // }
    if (!store.state.paramsBool){
      this.$router.push('/404')
    }
    let queryString = window.location.hash.split("?")[1];
      let urlParams = new URLSearchParams(queryString);

      if (urlParams.get("11")==null || urlParams.get("14")==null || urlParams.get("16")==null || urlParams.get("17")==null || urlParams.get("19")==null || urlParams.get("20")==null || urlParams.get("21")==null ){
        store.state.paramsBool = false
      } else {
        store.state.paramsBool = true
      }
    if(this.paramsBool) {
      this.benchmark2 = await fetch(window.location.protocol +
              "//" +
              window.location.host + 
              "/survey/getsurveys",{
                    method: "GET",
                    mode: "cors",
                    cache: "no-cache",
                    headers: {
                        'Content-Type': 'application/json',
                        '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
                    }}).then((data)=> {return data.json()}).then(data=>store.buildBenchmark(data))
    store.state.benchmark = this.benchmark2
    this.barcharts= [
      Object.values(this.benchmark2[2][0]),
      Object.values(this.benchmark2[6][0]),
      Object.values(this.benchmark2[1][0])
    ]
    this.barchartverts = [
      [Object.values(this.benchmark2[0][0]),Object.values(this.benchmark2[0][1]),Object.values(this.benchmark2[0][2])],
      [Object.values(this.benchmark2[5][0]),Object.values(this.benchmark2[5][1]),Object.values(this.benchmark2[5][2]),Object.values(this.benchmark2[5][3]),Object.values(this.benchmark2[5][4]),Object.values(this.benchmark2[5][5])],
      [Object.values(this.benchmark2[7][0]),Object.values(this.benchmark2[7][1]),Object.values(this.benchmark2[7][2]),Object.values(this.benchmark2[7][3]),Object.values(this.benchmark2[7][4]),Object.values(this.benchmark2[7][5]),Object.values(this.benchmark2[7][6])]
    ]
    this.barchartl2gs = [
      [Object.values(this.benchmark2[4][0]),Object.values(this.benchmark2[4][1])],
      [Object.values(this.benchmark2[3][0]),Object.values(this.benchmark2[3][1])]
    ]
    this.piecharts = [
      Object.values(this.benchmark2[8]),
      Object.values(this.benchmark2[9])
    ]
    this.tooltips = [
        [`As a reminder, answer choices for this item are: A great deal, often, somewhat, little, never. `,`${store.state.totals[0]} respondents completed this item.`],
        [`As a reminder, answer choices for this item are: Always, often, sometimes, rarely, never, unsure. `,`${store.state.totals[1]} respondents completed this item.`],
        [`As a reminder, answer choices for this item are: Included a great deal, included somewhat, included a little, not included. `,`${store.state.totals[2]} respondents completed this item.`],
        `${store.state.totals[3]} respondents completed this item.`,
        `${store.state.totals[4]} respondents completed this item.`,
        `${store.state.totals[5]} respondents completed this item.`,
        [`This question was a 'check all that apply' question, meaning that the percentages displayed below represent the percentage of total respondents who selected each option, and as such, the sum of responses will be more than 100%. `,`${this.benchmark2[4][1]} respondents completed this item.`],
        [`This question was a 'check all that apply' question, meaning that the percentages displayed below represent the percentage of total respondents who selected each option, and as such, the sum of responses will be more than 100%. `,`${this.benchmark2[3][1]} respondents completed this item`],
        `${store.state.totals[6]} respondents completed this item.`,
        `${store.state.totals[7]} respondents completed this item.`,
      ]
    }
    // console.log(this.barcharts,this.barchartverts, this.barchartl2gs, this.piecharts)
    this.dataReady = true
    
    // console.log("MOUNTED", store.state.benchmark, typeof(store.state.benchmark[2]))
  }
};
</script>
